import axios from "axios";

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;

const apiClient = axios.create({
  baseURL: baseUrl,
  timeout: 120000,
});

apiClient.interceptors.request.use((config) => {
  if (config.data instanceof FormData && config.headers) {
    config.headers["Content-Type"] = "multipart/form-data";
  }
  return config;
});

const cloudinaryUrl = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_NAME}`;

const uploadFileToCloudinary = async (file, onProgress) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);

  const response = await apiClient.post(`${cloudinaryUrl}/image/upload`, formData, {
    onUploadProgress: (progressEvent) => {
      if (progressEvent.total && typeof onProgress === "function") {
        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(progress);
      }
    },
  });
  return response;
};

/** Alias for callers that expect the `uploadFileCloudinary` name */
const uploadFileCloudinary = uploadFileToCloudinary;

export { uploadFileToCloudinary, uploadFileCloudinary };
